import { defineMessages } from 'react-intl';

export default defineMessages({
  nationalIdNumberExtraWithExtra: {
    id: 'cc4.form.personal-info.label.national-id-number-extra',
    defaultMessage: `National identification number {extra, select,
      bsn {(BSN)}
      nhs {(NHS)}
      insee {(INSEE)}
      dni {(DNI)}
      fiscal_code {(Fiscal code)}
      be {(BE)}
      pesel {(PESEL)}
      ssn {(SSN)}
      personal_public_service_number {(Personal public service number)}
      other {(Other)}
    }`,
  },
  nationalIdNumberExtra: {
    id: 'cc4.form.personal-info.label.national-id-number',
    defaultMessage: 'National identification number',
  },
});
